import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import sampleFileExpiry from "../../src/data/product_expiry_sample_file.xlsx";
import download_icon from "../../src/assets/download_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getInventorydashboard,
  getInventoryEditResttriction,
  UploadBulkInventory,
} from "../API  Functions/InventoryFunctions";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { Download } from "lucide-react";
import { message, Upload } from "antd";
import { setDashData } from "../Redux/Action/DashData";
import LoadingSpinner from "../components/Loading";
import checked from "../../src/assets/checked.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";

const BulkUploadExpiry = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const navigate = useNavigate();
 const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [fileError, setFileError] = useState("");
  const [base64File, setBase64File] = useState("");
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [bounceFile, setBounceFile] = useState(null); // State to store bounce details
  const userData = useSelector((state) => state?.login?.user?.result);

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 50,
    },
    container: {
      width: "40%",
      padding: successMessage == "" ? "30px" : "15px",
      borderRadius: "18px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 50,
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 5,
    },
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      textAlign: "center",
      marginBottom: "10px",
    },
    cancelIcon: {
      cursor: "pointer",
    },
    description: {
      textAlign: "center",
      fontSize: "16px",
      color: "#272728",
      marginTop: "10px",
    },
    input: {
      width: "100%",
      padding: "10px",
      borderRadius: "12px",
      border: "1px solid #CCCCCC",
      marginBottom: "20px",
      boxSizing: "border-box",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
    },
    button: {
      width: "180px",
      height: "45px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      marginRight: "10px",
      transition: "opacity 0.3s", // Smooth transition for opacity change
    },
    confirmButton: {
      backgroundColor: "primaryBlue",
      color: "#FFFFFF",
    },
    cancelButton: {
      backgroundColor: "#CCCCCC",
      color: "#000000",
    },
    image: {
      width: "70px",
      display: "block",
      margin: "20px auto",
      marginBottom: "20px",
    },
  };


  const isSubmitDisabled =
    loading ||
    !base64File;
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const payload = {
      company_id: company_id,
      file_data: base64File,
    };

    try {
    const response = await axiosInstance.post(
        URLS.UPLOAD_BULK_EXPIRY,
        payload,
      );


      if (response?.data?.result?.status_code === 200) {
        toast.success(t(response?.data?.result?.status));
        // setSuccessMessage(result?.result?.status);
        onClose();
        setBase64File(""); // Clear the base64 file
        setFileName(""); // Clear the file name
      } 
      if (response?.data?.result?.bounce_back_file) {
        // console.log("RESSS", result.result.bounce_details);
        setBounceFile(response?.data?.result?.bounce_back_file);
        setBase64File(""); // Clear the base64 file
        setFileName(""); // Clear the file name
        // }
      } else {
        setErrorMessage(
          response?.data?.message || "An error occurred during file upload."
        );
      }
    } catch (error) {
      setErrorMessage("Failed to upload file. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // console.log("BOUNCE DETAILS", bounceFile);

const downloadBounceExcel = () => {
  const base64Data = bounceFile;

  const linkSource =
    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
    base64Data;

  const downloadLink = document.createElement("a");
  const fileName = "bounce_details.xlsx";

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};


  // Function to trigger file download
  const downloadSampleFile = () => {
    const link = document.createElement("a");
      link.href = sampleFileExpiry; // use first file
      link.download = "product_expiry_sample_file.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "xls" && fileExtension !== "xlsx") {
        setFileError("Please upload a valid Excel file.");
        setBase64File("");
        setFileName(""); // Clear file name if the file type is invalid
      } else {
        setFileError("");
        setFileName(file.name); // Store the file name
        convertToBase64(file);
      }
    }
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64Data = reader.result.split(",")[1];
      setBase64File(base64Data);
    };
  };

  // console.log("base64File", base64File);

  // const isSubmitDisabled = loading || !base64File;

  return (
    <>
      {loading && <LoadingSpinner />}

      {isOpen && (
        <>
          {successMessage != "" ? (
            <div>
              <div style={styles.overlay}></div>
              <div style={styles.container}>
                <img
                  // src={checked}
                  src={checked}
                  alt="Checked"
                  style={styles.image}
                />
                {/* <p style={styles.title}>{t('successfull')}</p> */}
                <p style={styles.title}>{t("Successful")}</p>
                <p style={styles.description}>{t(successMessage)}</p>
                <div className="flex justify-center gap-5 mt-7 mb-7 w-full">
                  {/* <Link to={route}> */}
                  <button
                    type="button"
                    className="w-[180px] h-[45px] bg-white text-primaryBlue border border-primaryBlue rounded-lg font-semibold"
                    // onClick={handleGoToDashboard} // Call handleGoToDashboard onClick
                    onClick={() => {
                      setSuccessMessage("");
                      onClose();
                    }}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="button"
                    className="w-[180px] h-[45px] bg-primaryBlue text-white rounded-lg font-semibold"
                    // onClick={handleGoToDashboard} // Call handleGoToDashboard onClick
                    onClick={() => {
                      setSuccessMessage("");
                      onClose();
                      navigate("/settings/bulkupdatehistory");
                    }}
                  >
                    {t("Check Status")}
                  </button>
                  {/* </Link> */}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div
                className="backdrop-blur"
                style={styles.overlay}
                onClick={onClose}
              ></div>
              <div style={styles.container}>
                <div style={styles.header}>
                  <p style={styles.title}>
                    {t("Upload Bulk Expiry")}
                  </p>
                  <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
                </div>
                <form onSubmit={handleSubmit} className="space-y-6">
                  {/* Download Sample */}
                  <div className="flex items-center gap-2 text-black mt-5">
                    <span>{t("Download Sample File")}:</span>
                    <button
                      type="button"
                      className="text-blue-600 hover:text-blue-700"
                      onClick={downloadSampleFile}
                    >
                      <Download size={20} />
                    </button>
                  </div>

                  {/* File Upload */}
                  <div className="space-y-2 mt-4">
                    <h3 className="font-medium mb-2">{t("Upload File")}</h3>
                    <div className="border-2 border-dashed border-gray-300  bg-gray-100 rounded-lg p-8">
                      <div className="flex flex-col items-center">
                        <Upload className="w-5 h-5 text-gray-400 mb-2" />
                        {/* <p className="text-sm text-gray-500 mb-1"></p> */}
                        <input
                          type="file"
                          id="file-upload"
                          className="hidden"
                          onChange={handleFileUpload}
                          accept=".xlsx,.xls"
                        />
                        <button
                          type="button"
                          onClick={() =>
                            document.getElementById("file-upload").click()
                          }
                          className="bg-black text-white text-xs px-4 py-2 rounded-full mb-5"
                        >
                          {t("Choose Excel File")}
                        </button>
                      </div>
                    </div>
                    {fileName && (
                      <p className="text-sm text-gray-600 mt-2">
                        {t("Selected file")}: {fileName}
                      </p>
                    )}
                    {fileError && (
                      <p className="text-sm text-red-600">{fileError}</p>
                    )}
                  </div>

                  {bounceFile != null && (
                    <div className="mt-5">
                      <button
                        type="button"
                        className="w-full h-10 bg-[#78CFEC] text-white font-medium rounded-lg"
                        onClick={downloadBounceExcel}
                      >
                        {t("Download Error File")}
                      </button>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="grid grid-cols-3 gap-4 pt-4">
                    <button
                      type="button"
                      onClick={onClose}
                      className="w-full px-4 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      type="submit"
                      disabled={!base64File || loading}
                      className={`w-full px-4 py-2 rounded-lg font-semibold text-white ${
                        loading || !base64File
                          ? "bg-primaryBlue opacity-50 cursor-not-allowed"
                          : "bg-primaryBlue hover:bg-gray-600"
                      }`}
                      // className="w-full px-4 py-2 bg-primaryBlue text-white rounded-lg hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {t("Submit")}
                    </button>
                  </div>
                </form>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default BulkUploadExpiry;
